define([
    'moment',
    '../../services/errorHandler',
    '../../user/services/profile',
], function (moment) {
    return {
        name: 'cancelAccountController',
        arguments: [
            '$http',
            '$rootScope',
            '$scope',
            'ErrorHandler',
            'Profile',
            function ($http, $scope, $rootScope, ErrorHandler, Profile) {
                $scope.cancelStep = 'intro';
                $scope.cancellationReason = '';

                $scope.selectReason = function (reason, otherExplanation) {
                    switch (reason) {
                        case 'break':
                            if (
                                $rootScope.user.pausedUntil &&
                                moment($rootScope.user.pausedUntil).isAfter(
                                    moment(),
                                    'day'
                                )
                            ) {
                                $scope.cancelStep = 'confirm';
                            } else {
                                $scope.cancelStep = 'pause';
                            }
                            $scope.cancellationReason =
                                'Taking a temporary break';
                            break;
                        case 'other':
                            $scope.cancelStep = 'confirm';
                            $scope.cancellationReason =
                                'Other: ' + otherExplanation;
                            break;
                        case 'use':
                            if ($rootScope.user.requestedSupport) {
                                $scope.cancelStep = 'confirm';
                            } else {
                                $scope.cancelStep = 'offer';
                            }
                            $scope.cancellationReason = 'Hard to use';
                            break;
                        default:
                            if ($rootScope.user.discountUntil) {
                                $scope.cancelStep = 'confirm';
                            } else {
                                $scope.cancelStep = 'offer';
                            }
                            $scope.cancellationReason = 'Too expensive';
                    }
                };

                $scope.acceptSpecialOffer = function (cancelReason) {
                    $scope.offerErrors = [];
                    Profile.acceptCancelOffer(cancelReason)
                        .then(function () {
                            switch (cancelReason) {
                                case 'expense':
                                    $scope.cancelStep = 'confirm-discount';
                                    break;
                                case 'use':
                                    $scope.cancelStep = 'confirm-use';
                                    break;
                            }
                        })
                        .catch(function (error) {
                            $scope.offerErrors = ErrorHandler.getMessage(
                                error,
                                'There was a problem accepting the offer.  Please reload the page and try again.'
                            );
                        });
                };

                $scope.confirmCancellation = function () {
                    Profile.cancelAccount($scope.cancellationReason).then(
                        function () {
                            $scope.cancelStep = 'confirm-cancel';
                            $(document).on(
                                'close.fndtn.reveal',
                                '[data-reveal]',
                                function () {
                                    // User is cancelled and logged out, reload when they close the modal
                                    location.reload();
                                }
                            );
                        },
                        function (error) {
                            $scope.cancelErrors = ErrorHandler.getMessage(
                                error,
                                'There was a problem cancelling your account.  Please reload the page and try again.'
                            );
                        }
                    );
                };

                $scope.confirmPause = function (pauseLength) {
                    Profile.pauseAccount(pauseLength)
                        .then(function () {
                            $scope.cancelStep = 'confirm-pause';
                            $scope.pauseStep = 'confirm-pause';
                            $(document).on(
                                'close.fndtn.reveal',
                                '[data-reveal]',
                                function () {
                                    // Some page elements need to be re-parsed on the backend, so reloading the page
                                    location.reload();
                                }
                            );
                        })
                        .catch(function (error) {
                            $scope.pauseErrors = ErrorHandler.getMessage(
                                error,
                                'There was a problem pausing your account.  Please reload the page and try again.'
                            );
                        });
                };

                $scope.$on('reset-cancel', function () {
                    $scope.cancelStep = 'intro';
                    $scope.pauseStep = 'intro';
                });

                $scope.goToStep = function (newStep) {
                    $scope.cancelStep = newStep;
                    $scope.pauseStep = newStep;
                };
            },
        ],
    };
});
